var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3478_139387)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.0003,
    cy: 20.5,
    r: 17.0833,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 3.41699C23.2435 3.41699 25.4648 3.8584 27.5373 4.7168C29.61 5.57531 31.494 6.83359 33.0803 8.41992C34.6666 10.0063 35.9249 11.8902 36.7834 13.9629C37.6418 16.0354 38.0832 18.2567 38.0832 20.5C38.0832 23.8788 37.0814 27.1819 35.2043 29.9912C33.3272 32.8004 30.6588 34.9902 27.5373 36.2832C24.4159 37.576 20.9809 37.914 17.6672 37.2549C14.3535 36.5957 11.3092 34.9692 8.92013 32.5801C6.53104 30.191 4.90452 27.1468 4.24532 23.833C3.58619 20.5193 3.92416 17.0843 5.217 13.9629C6.50996 10.8414 8.69977 8.17303 11.509 6.2959C14.3183 4.41876 17.6214 3.41699 21.0002 3.41699ZM21.9807 26.6738C21.5125 26.48 20.9972 26.4295 20.5002 26.5283C20.0033 26.6272 19.547 26.8713 19.1887 27.2295C18.8303 27.5879 18.5854 28.0449 18.4865 28.542C18.3877 29.039 18.4391 29.5543 18.633 30.0225C18.8269 30.4905 19.1552 30.8904 19.5764 31.1719C19.9978 31.4534 20.4934 31.6045 21.0002 31.6045C21.6797 31.6045 22.3312 31.334 22.8117 30.8535C23.2922 30.373 23.5626 29.7215 23.5627 29.042C23.5627 28.5353 23.4126 28.0395 23.1311 27.6182C22.8495 27.1968 22.4489 26.8678 21.9807 26.6738ZM21.0002 9.39551C20.5471 9.39551 20.1126 9.57611 19.7922 9.89648C19.4719 10.2168 19.2922 10.6515 19.2922 11.1045V21.3545C19.2923 21.8075 19.4719 22.2422 19.7922 22.5625C20.1126 22.8828 20.5472 23.0625 21.0002 23.0625C21.4532 23.0625 21.8879 22.8828 22.2082 22.5625C22.5285 22.2422 22.7081 21.8075 22.7082 21.3545V11.1045C22.7082 10.6515 22.5285 10.2168 22.2082 9.89648C21.8878 9.57611 21.4533 9.39551 21.0002 9.39551Z",
    fill: "#F06D0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3478_139387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.32c9dadab34dc62793f275fc8344d9d1.svg";
export { ForwardRef as ReactComponent };